// extracted by mini-css-extract-plugin
export default {"title":"CasesOverview_title__rfCEx"};